import {
	ADDRESS_COMPONENT_ELEMENT_ID,
	COUNTERPARTIES_COMPONENT_ELEMENT_ID,
	IBAN_COMPONENT_ELEMENT_ID,
	INVESTOR_TEST_ELEMENT_ID,
	TEST_ELEMENT_IDS,
} from '@dealstack/shared/tests/testElementIds';

export {
	ADDRESS_COMPONENT_ELEMENT_ID,
	INVESTOR_TEST_ELEMENT_ID,
	TEST_ELEMENT_IDS,
} from '@dealstack/shared/tests/testElementIds';

interface Props {
	children?: React.ReactNode;
	identifier:
		| TEST_ELEMENT_IDS
		| IBAN_COMPONENT_ELEMENT_ID
		| INVESTOR_TEST_ELEMENT_ID
		| COUNTERPARTIES_COMPONENT_ELEMENT_ID
		| ADDRESS_COMPONENT_ELEMENT_ID;
	index?: string | number;
}

/**
 * @deprecated please use {@link Box} and replace {@link identifier} with {@link data-testid}
 */
export const UIElementIdentifier = ({ children, identifier, index }: Props) => {
	return (
		<div style={{ display: 'contents' }} data-testid={identifier} data-testindex={index}>
			{children}
		</div>
	);
};
